import React from 'react'
import MultiPartCard from '../MultiPartCard';
import { extractDataFromCourseForMultiCard } from './dataHelper';
import { TutorialCard } from './CourseTutorialCardStyles';

export default function CourseTutorialCards(props) {

    const { cardsData } = props;

    function checkSingleEpisode(data) {
        return (data?.course?.noOfEpisode > 1)
    }

    let filteredCardsData = cardsData?.filter(checkSingleEpisode);

    return (
        <TutorialCard>
            {filteredCardsData?.map((item, index) => {

                const dataForMultiPartCard = extractDataFromCourseForMultiCard(item);

                return (
                    <MultiPartCard
                        key={index}
                        data={dataForMultiPartCard}
                    />
                )
            })}
        </TutorialCard>
    )

}
